/**
 * Firefox for Android can't start an HTML5 drag from touch, so task cards
 * can't be dragged between columns there. This loads a polyfill that turns a
 * long press and move into synthetic drag events for Pragmatic to handle.
 */
export function installTouchDragPolyfill() {
  const ua = navigator.userAgent;
  // Chrome and Safari drag natively from touch; running the polyfill there too
  // would start two drags at once.
  if (!/Android/i.test(ua) || !/Firefox\//.test(ua)) return;

  // Pragmatic ends a drag once it sees about 20 pointermove events, because a
  // native drag suppresses them. A synthetic drag doesn't, so hide touch moves
  // from Pragmatic while one is running. Pragmatic binds its window listeners
  // when a drag starts, so these capture listeners always run first.
  let syntheticDragActive = false;
  window.addEventListener(
    "dragstart",
    () => {
      syntheticDragActive = true;
    },
    true,
  );
  window.addEventListener(
    "dragend",
    () => {
      syntheticDragActive = false;
    },
    true,
  );
  window.addEventListener(
    "pointermove",
    (e) => {
      if (syntheticDragActive && e.pointerType === "touch") {
        e.stopImmediatePropagation();
      }
    },
    true,
  );

  import("@dragdroptouch/drag-drop-touch").then(({ enableDragDropTouch }) => {
    enableDragDropTouch(document, document, {
      // Require a long press so swiping across a card still scrolls.
      isPressHoldMode: true,
      pressHoldDelayMS: 400,
      // The polyfill only blocks scrolling once the press completes, so a
      // finger that drifts further than this beforehand scrolls instead.
      pressHoldMargin: 8,
      // It only scrolls `window`; Pragmatic's auto-scroll handles our containers.
      allowDragScroll: false,
    });
  });
}
